module.exports = __webpack_public_path__ + "static/media/parcela.fef93101.svg";